import React from 'react'; // eslint-disable-line

export const TabPanel = (props: { value: number; index: number; children?: React.ReactNode }) => {
  if (props.value !== props.index) return null;
  return <React.Fragment>{props.children}</React.Fragment>;
};
